import { Banner, Text } from '@cloudflare/kumo'
import { CheckCircleIcon } from '@phosphor-icons/react'
import { useTranslation } from '../../i18n'
import { GuidedSelfie } from './selfie/GuidedSelfie'
import './enroll.css'

interface PhotoStepProps {
  error: string | null
  /** Receives the final cropped JPEG (data URL) from the guided capture. */
  onCapture: (dataUrl: string) => void
}

const TIP_KEYS = ['enroll.step3.tips.light', 'enroll.step3.tips.face', 'enroll.step3.tips.glasses']

/** Selfie capture step body: the guided camera capture, then tips (camera
 * only — there is no file-upload alternative). The page keeps the
 * upload/validation logic. */
export function PhotoStep({ error, onCapture }: PhotoStepProps) {
  const { t } = useTranslation()
  return (
    <div data-testid="enroll-step-photo" className="flex flex-col gap-4">
      {error && <Banner variant="error">{error}</Banner>}

      {/* Camera first so it is visible without scrolling on phones. */}
      <GuidedSelfie onCapture={onCapture} />

      <ul className="flex flex-col gap-2" aria-label={t('enroll.step3.tipsTitle')}>
        {TIP_KEYS.map((key) => (
          <li key={key} className="flex items-center gap-2">
            <CheckCircleIcon size={20} className="shrink-0 text-kumo-success" />
            <Text variant="secondary">{t(key)}</Text>
          </li>
        ))}
      </ul>
    </div>
  )
}
